import { useField } from 'formik';
import styled from 'styled-components';
import { RadioButton } from 'primereact/radiobutton';

const Label = styled.label`
    margin-left: 5px;
`;

const RadioInput = ({ label, onChange, ...props }) => {
    const [field] = useField({ ...props, type: 'radio' });

    const handleChange = (e) => {
        // Llama al onChange de Formik
        field.onChange(e);
        // Llama a tu función personalizada
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <div>
            <RadioButton
                type='radio'
                {...field}
                {...props}
                onChange={handleChange} // Usa el handleChange combinado
            />
            <Label className="ml-2">{label}</Label>
        </div>
    );
};

export default RadioInput;